<template>
  <section class="container py-5">
    <div class="row">
      <div class="col-md-12 mb-10">
        <div class="card mb-25 border-0 rounded-0">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">

            <div
              class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 mb-20">
              <h4 class="position-relative text-black fw-bold mb-10">
                Liste des candidatures pour l’offre : {{ offre?.titre || "..." }}
              </h4>
              <router-link to="/liste-offres" class="btn btn-primary transition border-0 lh-1 fw-medium">
                <i class="flaticon-left-arrow lh-1 me-1 position-relative top-2"></i>
                Retour
              </router-link>
            </div>


            <div v-if="loading" class="text-center">Chargement...</div>
            <div v-else-if="candidaters.length === 0" class="text-center text-muted">
              Aucune candidature trouvée.
            </div>


            <div v-else class="row">
              <div v-for="(c, index) in candidaters" :key="index" class="col-md-4 mb-4">
                <div class="card h-100 shadow-sm border-0">
                  <div class="card-body">
                    <h5 class="card-title">{{ c.prenom }} {{ c.nom }}</h5> 
                     <router-link class="btn btn-sm btn-outline-primary"
                        :to="{ name: 'CandidaterDetailsPage', params: { id: c.id } }">
                        Détails
                      </router-link>
                    <p class="mb-1"><strong>Qualification :</strong> {{ c.qualification || "Non spécifiée" }}</p>
                    <p class="mb-1"><strong>Expérience :</strong> {{ c.anneeExperience || 0 }} ans</p>
                    <p class="mb-1"><strong>Date candidature :</strong> {{ formatDate(c.dateCandidature) }}</p>


                    <div class="mt-3">
                      <span class="badge bg-info" v-if="c.estSelectionner">Sélectionné</span>
                      <button v-else class="btn btn-sm btn-outline-success" @click="selectionnerCandidater(c.id)"
                        :disabled="selecting">
                        Sélectionner
                      </button>
                     
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import ApiService from "@/services/ApiService";
import Swal from "sweetalert2";

export default defineComponent({
  name: "CandidatureOffre",
  setup() {
    const route = useRoute();
    const candidaters = ref<any[]>([]);
    const loading = ref(true);
    const selecting = ref(false);
    const offre = ref<any>(null);


    const fetchCandidaters = async () => {
      try {

        const { data: offreData } = await ApiService.get(`/offres/${route.params.id}`);
        offre.value = offreData.data;


        const { data } = await ApiService.get(`/offres/${route.params.id}/postulants`);
        candidaters.value = data; // format du backend : { code, message, data }
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    };


    const selectionnerCandidater = async (id: number) => {
      selecting.value = true;
      try {
        const { data } = await ApiService.put(`/candidaters/${id}/selection`, {});

        Swal.fire({
          text: data.message || "Candidat sélectionné avec succès",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

        // Met à jour la liste localement
        candidaters.value = candidaters.value.map((c) => ({
          ...c,
          estSelectionner: c.id === id,
        }));

      } catch (error) {
        Swal.fire({
          text: "Erreur lors de la sélection du candidat",
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        selecting.value = false;
      }
    };



    const formatDate = (date: string) => new Date(date).toLocaleDateString();

    onMounted(() => {
      fetchCandidaters();
    });

    return { candidaters, loading, selecting, selectionnerCandidater, formatDate, offre };
  },
});
</script>
